require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-packages-search-engine-optimization.json") })
        }
      }, "path---services-packages-search-engine-optimization");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-packages-search-engine-optimization!./.cache/json/services-packages-search-engine-optimization.json
// module id = 749
// module chunks = 231608221292675